export const APP_STORE_ANDROID =
  "https://play.google.com/store/apps/details?id=com.bumblebff.app&ref=web-direct-cta&d=Desktop";
export const APP_STORE_IOS =
  "https://apps.apple.com/us/app/bumble-for-friends-meet-irl/id6444040977?ref=web-direct-cta&d=Desktop";
